module.exports = __webpack_public_path__ + "img/i-share-mail.d5fe33ee.svg";